export const MAPBOX_ACCESS_TOKEN =
	'pk.eyJ1IjoiYnJlbmRhbmRpZ3Njb25uZWN0IiwiYSI6ImNqb2U2eHBrYTFmZTkza21yMHZmb2YycDIifQ.17gD0BvU7B1rXjDqthO8RA';
export const GOOGLE_PLACES_API_KEY = 'AIzaSyDJhqu1lLQZKV3ni7MpuhWWfTho1v57wgQ';
